export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="bg-background-50 rounded-3xl overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center">
              <div className="flex-1 p-8 md:p-12 lg:p-16 text-center lg:text-left">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">移动端观影</h2>
                <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-md mx-auto lg:mx-0">
                  片多多影视全面支持手机浏览器访问，无需下载APP即可畅享高清观影体验。片多多高清免费、片多多高清不卡，随时随地想看就看。
                </p>
                <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4">
                  <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-background-100">
                    <i className="ri-smartphone-line text-primary-500 text-lg"></i>
                    <span className="text-sm text-foreground-700">手机浏览器直接访问</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-background-100">
                    <i className="ri-wifi-line text-accent-500 text-lg"></i>
                    <span className="text-sm text-foreground-700">无需下载安装</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-background-100">
                    <i className="ri-hd-line text-primary-500 text-lg"></i>
                    <span className="text-sm text-foreground-700">自适应高清画质</span>
                  </div>
                </div>
                <div className="mt-6">
                  <a
                    href="#hero"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg text-sm md:text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-play-circle-line"></i>
                    立即体验
                  </a>
                </div>
              </div>
              <div className="flex-1 flex justify-center p-6 md:p-10">
                <div className="relative">
                  <div className="w-48 md:w-56 h-auto rounded-2xl overflow-hidden bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20showing%20a%20movie%20streaming%20app%20interface%20with%20Chinese%20film%20posters%20and%20warm%20golden%20dark%20theme%2C%20clean%20minimal%20UI%20design%2C%20premium%20product%20photography%20with%20soft%20lighting%2C%20isolated%20on%20clean%20background&width=600&height=1000&seq=app-mobile&orientation=portrait"
                      alt="片多多影视手机端观影界面"
                      className="w-full h-auto object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}